<script>
import {computed} from "vue";
import {formatDateTime} from "@/tools/date-time.tools";
import {openImagePreview} from "@/composables/image-preview";

export default {
  name: "ClubNewsCard",
  props: ['newsItem'],
  setup(props) {
    const newsTime = computed(() => {
      return formatDateTime(props.newsItem.created_at);
    })
    return {newsTime, openImagePreview}
  }
}
</script>

<template>
  <div class="clubNewsCard">
     <div class="clubNewsCard__header">
       <img class="clubNewsCard__headerImage" alt="" :src="require('@/assets/img/club-news/card-icon.png')">
       <div class="clubNewsCard__headerContent">
          <span>{{newsItem.author}}</span>
          <span>{{newsTime}}</span>
       </div>
     </div>
     <img class="clubNewsCard__image" alt="" :src="newsItem.img_url" @click="openImagePreview(newsItem.img_url)">
     <div class="clubNewsCard__text" v-html="newsItem.body">
     </div>
  </div>
</template>

<style scoped lang="scss">
.clubNewsCard {
  border-radius: var(--cd-card-border-radius);
  background-color: var(--cd-card-bg);
  display: flex;
  flex-direction: column;
  gap: 10px;
  padding: 10px;
  &__header {
    display: flex;
    gap: 10px;
    span {
      display: block;
    }
  }
  &__text {
    white-space: pre-wrap;

    :deep(p),
    :deep(ul),
    :deep(ol),
    :deep(blockquote) {
      margin: 0 0 1em;
    }

    :deep(h1),
    :deep(h2),
    :deep(h3),
    :deep(h4),
    :deep(h5),
    :deep(h6) {
      margin: 1em 0 0.5em;
    }

    :deep(li + li) {
      margin-top: 0.25em;
    }

    :deep(a) {
      color: var(--cd-highlight-text);
    }
  }
  &__image {
    max-width: 100%;
    height: auto;
    cursor: zoom-in;
  }
}
</style>
